export class FileUploadRequest {
  payload = new FormData();

  constructor(file: File) {
    this.payload.append("file", file);
  }
}
